export const CONFIG = {
  WS_URL: import.meta.env.VITE_WS_URL,
  API_URL: import.meta.env.VITE_API_URL,
  AGENCY_ID: import.meta.env.VITE_REGENT_AGENCY_ID || 1,
  ENV_MODE: import.meta.env.MODE,
  GOOGLE_KEY: import.meta.env.VITE_GOOGLE_KEY,
  /**
   * Mapas de Rutero y hoteles, restringida por dominio y API.
   * Requiere Embed y Maps JavaScript (solo el mapa general de hoteles).
   * El mapa general aísla su SDK en un iframe; GOOGLE_KEY sigue atendiendo
   * los consumidores anteriores de JavaScript/Places y Static.
   */
  MAPS_EMBED_KEY: import.meta.env.VITE_GOOGLE_MAPS_EMBED_KEY,
};
